import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Header = ({ onRefresh, isRefreshing }) => {
  const logoUrl = "https://ewz2g94uc42.exactdn.com/wp-content/uploads/2026/07/cropped-sulit-logo-3.png?strip=all&fit=176%2C73";
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/">
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="flex items-center gap-3">
            <img src={logoUrl} alt="Sulit.ph" className="h-8 w-auto object-contain" />
            <div className="h-4 w-[1px] bg-gray-200 mx-1 hidden sm:block"></div>
            <h1 className="font-serif text-sm font-bold tracking-[0.2em] text-gray-400 hidden sm:block uppercase">
              Sulit Lifestyle
            </h1>
          </motion.div>
        </Link>

        <div className="flex items-center gap-2">
          {isHomePage ? (
            <>
              <Link 
                to="/download" 
                className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold tracking-wide uppercase rounded-full shadow-sm transition-all hover:shadow-md mr-1 flex items-center gap-1.5"
              >
                <SafeIcon icon={FiIcons.FiDownload} /> App
              </Link>
              <motion.button 
                whileTap={{ scale: 0.95 }} 
                onClick={onRefresh} 
                disabled={isRefreshing} 
                className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-full transition-colors bg-gray-50/50"
                aria-label="Refresh feed"
              >
                <motion.div animate={{ rotate: isRefreshing ? 360 : 0 }} transition={{ duration: 1, repeat: isRefreshing ? Infinity : 0, ease: "linear" }}>
                  <SafeIcon icon={FiIcons.FiRefreshCw} className="text-lg" />
                </motion.div>
              </motion.button>
            </>
          ) : (
            <Link 
              to="/" 
              className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-full transition-colors bg-gray-50/50"
              aria-label="Close"
            >
              <SafeIcon icon={FiIcons.FiX} className="text-xl" />
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;